<template>
	<section class="editor-from">
		<div class="header">
			<div v-if="inited" class="header-left">
				<h2>{{content.catalogName}}</h2>
				<el-tag v-if="inited" style="margin-left:10px">
					{{!content.approveStatus||content.approveStatus.code==0?content.status.description:content.approveStatus.description}}
				</el-tag>

			</div>
			<div v-if="inited" class="header-right" style="line-height:40px">
				<span class="label">{{content.author.name}} | {{content.createTime}}</span>
				<el-button type='primary' size="mini"
					v-if="content.status.code==0 && (!content.approveStatus||content.approveStatus.code==3)"
					@click="submit(true)" :disabled="loading">发布</el-button>
				<el-button type='primary' size="mini" @click="submit(false)" :disabled="loading">关闭</el-button>
			</div>
		</div>
		<ql-toolbar ref="toolbarRef">
			<template v-slot:middle>
				<ql-content-save :key="doc.id" :getContentId="getContentId" ref="contentSaveRef" />
			</template>
		</ql-toolbar>
		<div class="contain" v-loading="loading" :element-loading-text="loadingText">
			<div class="content" id="quill-scroll-contain">
				<div class="article">
					<div class="extra-info">
						<el-upload :action="uploadUrl" :headers="headers" :show-file-list="false"
							:on-success="onAvatarSuccess" class="avatar-uploader">
							<el-image :src="extraJson.avatar" class="avatar" fit='cover' />
						</el-upload>
						<el-input v-model="extraJson.name" class="name" placeholder="请输入姓名" />
						<el-date-picker v-model="extraJson.date" value-format="yyyy年MM月dd日" placeholder="请选择入党时间"
							style="width:200px;" />
						<el-input v-model="extraJson.description" type="textarea" :rows="3" placeholder="座右铭"
							style="width:300px;" :maxlength="30" show-word-limit />
					</div>
					<div style="position: relative">
						<ql-editor :id="doc.id" ref="editorRef" style="padding:0 15px" />
					</div>
				</div>
			</div>
		</div>
		<select-file ref="selectFileRef" @complete="onSelectComplete" />
	</section>
</template>

<script>
	import { documentApi } from '@/boot-api/record'
	import { contentApi } from '@/boot-api/cms'
	import SelectFolder from '@/views/vdisk/select-folder.vue'
	import SelectFile from '@/views/vdisk/select-file.vue'
	import SelectUser from '@/components/select-user.vue'
	import { mapState } from 'vuex'

	export default {
		components: {
			SelectFolder, SelectFile, SelectUser
		},
		data() {
			return {
				doc: {},
				status: 'add',
				headerImageId: 0,
				loading: false,
				loadingText: '正在加载',
				submiting: false,
				fromPath: '',
				// 是否已经初始化完成了
				inited: false,
				catalogId: 0,
				approve: false,
				id: null,
				extraJson: {},
				content: {

				} // 获取cms conent的分类 和状态

			}
		},
		computed: {
			...mapState('common', ['uploadUrl', 'defaultAvatar', 'headers'])
		},
		methods: {
			// id=contentId
			async open(id) {
				this.doc = { headerImage: '', content: '' }
				this.id = id

				this.loading = true
				this.inited = false
				this.loadingText = '正在加载...'

				this.content = await contentApi.getContent({ id, type: 1 }).then(res => res.data)
				this.extraJson = this.content.extraJson || { avatar: this.defaultAvatar }
				this.doc = await documentApi.getDetail({ id: this.content.fileId }).then(res => res.data)
				this.headerImageId = this.doc.imageId
				const quill = this.$refs.editorRef.init({
					toolbar: true,
					ops: this.doc.ops
				})
				this.$refs.toolbarRef.init(quill)
				this.$refs.contentSaveRef.init(quill)
				this.loading = false
				this.inited = true
			},

			// 关闭前的保存
			async submit(release = false) {
				if (!this.$refs.contentSaveRef.checkSaveStatus()) {
					this.$message.error('修改尚未保存完成，请稍等关闭！')
					return;
				}
				this.doc.title = this.extraJson.name
				if (!this.doc.title || this.doc.title == '') {
					let drop = false
					await this.$prompt('请输入标题', '提示', {
						cancelButtonText: '删除文档'
					}).then(({ value }) => {
						this.doc.title = value

						this.extraJson.name = value
					}).catch(async () => {
						await contentApi.remove([this.id])
						drop = true
					})
					if (drop) {
						this.$router.back()
						return
					}
				}
				this.loading = true
				this.loadingText = '正在保存实录，请稍等...'

				await this.save()
				this.extraJson.showType = 1
				await contentApi.save({ id: this.content.id, extraJson: this.extraJson })
				if (release) {
					await contentApi.release({ id: this.content.id })
					this.$message.success(this.approve ? '已经发送审核,请等待审核结果' : '发布成功')
				} else {
					this.$message.success('保存成功')
				}
				this.loading = false
				this.$router.back()
			},
			async save() {
				const res = await documentApi.save({
					id: this.doc.id,
					title: this.doc.title,
					summary: this.$refs.editorRef.getSummary(),
					imageId: this.headerImageId
				})

				return res.data
			},


			onSelectComplete(result) {
				const item = result.data[0]
				this.doc.headerImage = item.path
				this.headerImageId = item.id
				if (this.doc.id) {
					documentApi.save({ id: this.doc.id, imageId: this.headerImageId })
				}
			},
			onRemoveHeaderImage() {
				this.doc.headerImage = ''
				this.headerImageId = 0
				documentApi.save({ id: this.doc.id, imageId: this.headerImageId })
			},
			approveCommit() {
				this.$msgbox({
					title: '请选择审核人员',
					beforeClose: (action, instance, done) => {
						if (action == 'confirm') {
							const userId = this.$refs.selectCheckerRef.getUserId()
							if (userId == null) {
								this.$message.error('请选择审核人员')
								return
							}
							// approveApi.commit({ docId: this.doc.id, checkerId: userId }).then(res => {
							// 	this.doc.status = {
							// 		code: 2,
							// 		description: '待审核'
							// 	}
							// 	this.$message.success('提交成功')
							// })
						}
						done()
					},
					message: <select-user style="width:100%" filterable key={Math.random()} ref='selectCheckerRef' />
				})
			},
			approveRevoke() {
				approveApi.revoke({ docId: this.doc.id }).then(res => {
					if (res.data) {
						this.doc.status = {
							code: 1,
							description: '正常'
						}
						this.$message.success('撤销成功')
					}

				})
			},
			async getContentId() {
				return await documentApi.getContentId({ docId: this.doc.id }).then(res => res.data)
			},

			onAvatarSuccess(res) {
				if (res.data) {
					this.extraJson.avatar = res.data.fullPath
					console.log('this.extraJson.avatar=', this.extraJson)
				} else {
					this.$message.error('上传失败')
				}

			}

		},



		async mounted() {
			console.log('this.headers=', this.headers)
			const id = this.$route.query.id
			const catalogId = this.$route.query.catalogId
			// 内容是前端创建，还是后端创建
			const from = this.$route.query.from
			this.approve = this.$route.query.approve
			if (!id) {
				this.doc.id = await documentApi.init({ tplName: `cms-${catalogId}`, from: 2 }).then(res => res.data)
				const contentId = await contentApi.save({
					fileId: this.doc.id,
					catalogId,
					size: 0,
					type: 1,
					status: 0,
					approveStatus: 0,
					from: parseInt(from)
				}).then(res => res.data)
				this.$router.replace(this.$route.fullPath + '&id=' + contentId)
				this.open(contentId)
			} else {
				this.open(id)
			}

		},


	}
</script>

<style lang="scss" scoped>
	.extra-info {
		display: flex;
		flex-direction: column;
		align-items: center;
		width: 100%;
		margin-top: 30px;
		.name {
			width: 120px;
			font-size: 18px;
			& /deep/ .el-input__inner {
				border: none;
				text-align: center;
				font-weight: bold;
				color: #303133;
			}
		}
		& /deep/ .el-input__inner {
			border: none;
			text-align: center;
			color: #303133;
		}
		& /deep/ .el-textarea__inner {
			border: none;
			text-align: center;
			color: #303133;
		}
	}
	.avatar-uploader {
		margin-bottom: 20px;
		& /deep/.el-upload {
			border: 1px dashed #d9d9d9;
			border-radius: 6px;
			cursor: pointer;
			position: relative;
			overflow: hidden;
		}
		.avatar {
			width: 140px;
			height: 160px;
			display: block;
			& /deep/ .el-image__inner {
				object-position: top;
			}
		}
	}
	.header-left {
		display: flex;
		align-items: center;
	}
	.header-right {
		.label {
			font-size: 14px;
			color: #909399;
			margin-right: 20px;
		}
	}
	.folder-path {
		width: 300px;
		margin-left: 6px;
	}
	.folder-path /deep/ .el-input__inner {
		border: none;
		font-size: 16px;
		font-weight: bold;
		color: #303133;
		background-color: #f1f2f5;
		vertical-align: middle;
		padding: 0;
	}
	.header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		height: 50px;
		padding: 0 10px;
	}
	.content {
		height: calc(100% - 100px);
		overflow: auto;
	}
	.contain {
		position: relative;
	}

	.article.left {
		margin-right: calc(50% - 400px + 150px);
	}
	.article {
		position: relative;
		border: 1px solid #e8e8e8;
		width: 800px;
		margin-right: auto;
		margin-left: auto;
		margin-bottom: 20px;
		margin-top: 20px;
		min-height: 1000px;
		background-color: white;
		.article-header {
			position: relative;
			.btns {
				position: absolute;
				bottom: 10px;
				right: 30px;
			}
		}
		.title {
			width: 100%;
			border: none;
			outline: none;
			font-size: 20px;
			font-weight: bold;
			padding: 10px 30px;
		}
		.header-image-btn {
			margin: 50px 0 0 30px;
		}
		.header-image {
			height: 220px;
			width: 100%;
		}
	}
	.temple-list {
		width: 100%;
		position: fixed;
		z-index: 999;
		bottom: 0;
	}
	.el-tag {
		line-height: 24px;
		height: 24px;
		margin-right: 10px;
	}
</style>


// WEBPACK FOOTER //
// src/views/cms/content/profile-editor.vue